var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2139_4986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 10.6673V12.534C5.33337 13.2807 5.33337 13.6541 5.4787 13.9393C5.60653 14.1902 5.8105 14.3942 6.06139 14.522C6.3466 14.6673 6.71997 14.6673 7.46671 14.6673H12.5334C13.2801 14.6673 13.6535 14.6673 13.9387 14.522C14.1896 14.3942 14.3936 14.1902 14.5214 13.9393C14.6667 13.6541 14.6667 13.2807 14.6667 12.534V7.46732C14.6667 6.72058 14.6667 6.34721 14.5214 6.062C14.3936 5.81111 14.1896 5.60714 13.9387 5.47931C13.6535 5.33398 13.2801 5.33398 12.5334 5.33398H10.6667M3.46671 10.6673H8.53337C9.28011 10.6673 9.65348 10.6673 9.93869 10.522C10.1896 10.3942 10.3936 10.1902 10.5214 9.93931C10.6667 9.65409 10.6667 9.28072 10.6667 8.53398V3.46732C10.6667 2.72058 10.6667 2.34721 10.5214 2.062C10.3936 1.81111 10.1896 1.60714 9.93869 1.47931C9.65348 1.33398 9.28011 1.33398 8.53337 1.33398H3.46671C2.71997 1.33398 2.3466 1.33398 2.06139 1.47931C1.8105 1.60714 1.60653 1.81111 1.4787 2.062C1.33337 2.34721 1.33337 2.72058 1.33337 3.46732V8.53398C1.33337 9.28072 1.33337 9.65409 1.4787 9.93931C1.60653 10.1902 1.8105 10.3942 2.06139 10.522C2.3466 10.6673 2.71997 10.6673 3.46671 10.6673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2139_4986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a621ad4dd8fca0b4b1791b960a350ce9.svg";
export { ForwardRef as ReactComponent };